<template>
  <el-card class="SearchBox">
    <el-form ref="ruleFormRef" :model="ruleForm" label-width="90px" class="search-ruleForm" size="default" status-icon>
      <el-form-item :label="props.searchList['operName']" prop="operName">
        <el-input clearable v-model="ruleForm.operName" type="text" placeholder="输入操作人" />
      </el-form-item>
      <el-form-item :label="props.searchList['roleId']" prop="roleId">
        <el-select  clearable v-model="ruleForm.roleId" placeholder="选择类型">
          <el-option v-for="item in OptionsMenuId" :key="item.roleId" :label="item.roleName" :value="item.roleId" >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="searchList['operTime']" prop="dateRange">
        <el-config-provider :locale="zhCn">
        <el-date-picker v-model="ruleForm.dateRange" type="daterange" start-placeholder="开始" end-placeholder="结束"
          :default-time="defaultTime" @change="getSTime" value-format="YYYY-MM-DD"/>
          </el-config-provider>
      </el-form-item>
      <el-button color="#4886FF" :icon="Search" @click="submitForm(ruleFormRef)">搜索</el-button>
      <el-button color="#f1f2f4" class="RefreshLeft" :icon="RefreshLeft" @click="resetForm(ruleFormRef)">重置</el-button>
    </el-form>
  </el-card>
</template>

<script lang="ts" setup>
import { Search, RefreshLeft } from '@element-plus/icons-vue'
import { reactive, ref } from 'vue'
import type { FormInstance } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
interface RuleForm {
  operName: string
  roleId: string
  dateRange: any
}
interface OptionMenuId {
  roleId: string
  roleName: string
}

const props = defineProps({
  searchList: {
    type: Object, default: {
      'operName': '操作人',
      'roleId': '角色名称',
      'operTime': '操作时间'
    }
  },
  OptionsMenuId: Array as () => Array<OptionMenuId>
})

const emit = defineEmits(["resetForm", "getRuleForm", "setTime"])

const defaultTime = ref<[Date, Date]>([
  new Date(),
  new Date(),
])
const ruleFormRef = ref<FormInstance>()
const ruleForm = reactive<RuleForm>({
  operName: "",
  roleId: "",
  dateRange: [] as any[]
})
const getSTime = (val: any) => {
  ruleForm.dateRange = val
  emit("setTime", val)
}

const submitForm = async (formEl: FormInstance | undefined) => {

  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log(ruleForm,'ruleForm');
      
      emit('getRuleForm', ruleForm)
    } else {
      console.log('error submit!', fields)
    }
  })
}

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.resetFields()
  emit('getRuleForm', ruleForm)
}
</script>

<style lang="scss" scoped>
.SearchBox {
  margin: 16px 0;

  .el-input {
    width: 190px;
  }

  ::v-deep .el-form-item--default .el-form-item__label {
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
  }

  .search-ruleForm {
    display: flex;
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-button {
      width: 72px;
      height: 32px;
      color: #FFF;
      margin-left: 32px;
      font-size: 15px;
    }

    ::v-deep .el-date-editor.el-input__wrapper {
      width: 200px !important;
    }
  }
}
</style>